module.exports = __webpack_public_path__ + "media/1.40fddc60.wav";